module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-kingmaker.223852bf.png";